import { updateCount as updateFaviconCount } from 'util/favicon'
import {
  ROOMS_REALTIME_LOAD_UNREAD,
  ROOMS_REALTIME_SYNC_UNREAD,
} from 'subapps/chat/actionTypes/rooms'

const defaultState = {
  unreadRoomIds: [],
}

const reducers = {}
window.updateFaviconCount = updateFaviconCount

reducers[ROOMS_REALTIME_SYNC_UNREAD] = (state, action) => {
  const {
    payload: { roomId, isRead },
  } = action
  let changed = false
  let newUnreadRoomIds

  if (state.unreadRoomIds.includes(roomId) && isRead) {
    newUnreadRoomIds = state.unreadRoomIds.filter(rId => rId !== roomId)
    changed = true
  } else if (!state.unreadRoomIds.includes(roomId) && !isRead) {
    newUnreadRoomIds = [...state.unreadRoomIds, roomId]
    changed = true
  }
  if (!changed) return state
  updateFaviconCount(newUnreadRoomIds.length)
  return {
    ...state,
    unreadRoomIds: newUnreadRoomIds,
  }
}

reducers[ROOMS_REALTIME_LOAD_UNREAD] = (state, action) => {
  const { payload: unreadRoomIds } = action

  updateFaviconCount(unreadRoomIds.length)
  return {
    ...state,
    unreadRoomIds,
  }
}

export default function reducer(state = defaultState, action) {
  // this is here because a long reducer with many ifs is unreadable
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
